import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

if (!supabaseUrl || !supabaseKey) {
  console.error('Supabaseの設定が不完全です。環境変数を確認してください。');
}

// Auth0 の ID トークンを返す関数（ログイン後に App.js から設定される）
// Supabase は ID トークンの `role` claim を見て Postgres のロールを決める。
let tokenGetter = null;

export const setSupabaseTokenGetter = (getter) => {
  tokenGetter = getter;
};

export const supabaseClient = createClient(supabaseUrl, supabaseKey, {
  // Supabase Auth ではなく Auth0 でログインするため、リクエストごとに Auth0 の ID トークンを付与する。
  // null を返した場合は Publishable key（anon）のまま送信される。
  accessToken: async () => {
    if (!tokenGetter) return null;
    try {
      return await tokenGetter();
    } catch (error) {
      console.error('Auth0 トークンの取得に失敗しました:', error);
      return null;
    }
  },
  db: {
    schema: 'public',
  },
});
